/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'
import { IconButton, Radio, useTheme } from "@mui/material";
import { ControlLabel, LabelWrapper, Popular, RadioWrapper, StyledModeEditIcon } from './styles';
import CheckIcon from '../Icons/CheckIcon';
import UncheckIcon from '../Icons/UncheckIcon';

interface Props {
	checked: boolean,
	value: string,
	label: string,
	label2?: string,
	popular?: boolean,
	handleEdit?: () => void,
	showEdit?: boolean,
}

const RadioButton = ({ checked, value, label, label2, popular, handleEdit, showEdit }: Props) => {
	const theme = useTheme();
	const Label = (
		<LabelWrapper>
			<div>
				{label}
				<br/>
				{label2}
			</div>
			{popular && <Popular>Popular</Popular>}
		</LabelWrapper>
	)
	return (
		<RadioWrapper>
			<ControlLabel
				checked={checked}
				control={
					<Radio
						value={value}
						disableRipple
						icon={<UncheckIcon htmlColor={theme.palette.secondary.main} sx={{ width: 12, height: 13 }}
						/>}
						checkedIcon={<CheckIcon htmlColor={theme.palette.primary.light} sx={{ width: 12, height: 13 }}/>}
					/>
				}
				label={Label}/>
			{showEdit && (
				<IconButton onClick={handleEdit} sx={{ padding: '0', backgroundColor: 'transparent' }}>
					<StyledModeEditIcon/>
				</IconButton>
			)}
		</RadioWrapper>
	)
}

export default RadioButton
